import GoalPauseReleaseTour from './GoalPauseReleaseTour';

export default GoalPauseReleaseTour;
